import React, { useEffect, useState } from "react";
import styles from "./ModalInputPrice.module.scss";
import { Modal } from "../../ui/Modal/Modal";
import Button from "../../ui/Button/Button";
import { useDispatch, useSelector } from "react-redux";
import { refillBalance } from "../../utils/api/actions/billing";
import { ClipLoader } from "react-spinners";
import RubleInput from "../../ui/RubleInput/RubleInput";

export const ModalInputPrice = ({ visible, handleClose }) => {
  const dispatch = useDispatch();

  const user = useSelector((state) => state?.user?.data);

  const [sum, setSum] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const isValid = sum.length > 0;

  useEffect(() => {
    if (!visible) {
      setSum("");
    }
  }, [visible]);

  const handleRefillBalance = () => {
    const numericSum = parseFloat(sum.replace(/\s/g, "").replace(/[₽]/g, ""));
    if (isNaN(numericSum)) {
      console.error("Invalid sum");
      return;
    }
    let data = {
      userId: user.id,
      sum: numericSum,
    };
    dispatch(refillBalance(data, handleClose, setIsLoading));
    setSum("");
  };

  return (
    <Modal visible={visible} handleClose={handleClose}>
      <div className={styles.container}>
        <div className={styles.title}>Введите сумму пополнения</div>
        <RubleInput amount={sum} setAmount={setSum} />
        <Button
          className={isValid ? styles.button : styles.disabled}
          titleClassName={styles.buttonTitle}
          title={isLoading ? "Подождите" : "Пополнить"}
          leftIcon={
            isLoading && (
              <ClipLoader
                style={{ marginRight: "10px" }}
                size={12}
                color="white"
              />
            )
          }
          onClick={isValid ? handleRefillBalance : undefined}
        />
      </div>
    </Modal>
  );
};
